import React from "react";
import {FaLinkedin,FaEnvelope,FaBitbucket} from "react-icons/fa"
import { Link } from 'react-scroll'
const HeroSection=()=>{
    return(
      <div className="md:h-screen w-full py-5" name="home">
        <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
          <div className="flex flex-col justify-center h-full">
            <h2 className="text-4xl sm:text-5xl font-bold">I'm Bhavesh Hindocha,Front-End Developer by passion.</h2>
            
            <p className="pt-3 max-w-md">I am always ready to learn new tools and technologies. I am passionate about web application development as I really practiced with React, bootstrap and Tailwind to work as a front-end developer.</p>
            <div className="py-2 flex">
            <a href="https://www.linkedin.com/in/bhavesh-hindocha-184739181" rel="noreferrer" target="_blank" className="px-2 text-black hover:text-cyan-500"><FaLinkedin size={30}/></a>
            <a href="mailto:bhavesh.hindocha.03@gmail.com" target="_blank" rel="noreferrer" className="px-2 text-black"><FaEnvelope size={30}/></a>
            <a href="https://bitbucket.org/Bhavesh2905/"  target="_blank" rel="noreferrer" className="px-2 text-black"><FaBitbucket size={30}/></a>
          </div>
          <div>
          <Link to="contact" smooth duration={1000}>
          <button className="w-fit px-5 py-3 my-2 flex items-center rounded-md border-purple-500	border-2 hover:bg-gradient-to-r hover:from-purple-500 hover:to-blue-500 cursor-pointer text-black">
           Contact
          </button>
          </Link>
          </div>
          </div>
        <div className="ml-5">
          <img src="/HeroImage.jpg" alt="my profile" className="w-3/3  rounded-2xl mx-auto"  />
        </div>
        </div>

      </div>
    )
}

export default HeroSection;